import dayjs from 'dayjs'

export default {
  SET_MODE: function(state, payload) {
    if (payload) {
      state.mode = ['development', 'production'].includes(payload) ? payload : 'development'
    }
    else {
      payload = 'production'
    }
  },
  SET_ENDPOINT: function(state, payload) {
    state.endpoint = payload
  },

  SET_CONNECT_STATE: function(state, payload) {
    state.oAuth2ConnectTime = new Date()
    state.oAuth2State = payload
  },

  SET_CONNECTED: function(state, payload) {
    if (payload !== undefined) {
      state.isConnected = true
      state.isConnectedExpires = dayjs(payload).subtract('15', 'minute').toISOString()
      state.isConnectedTimestamp = new Date().getTime()
      state.tokenExpires = payload
    }
    else {
      state.isConnected = false
      state.isConnectedExpires = null
      state.isConnectedTimestamp = null
      state.tokenExpires = null
    }
  },
  SET_LOCATION: function(state, payload) {
    state.location = payload
  },
  SET_SQUARE_CARD: function(state, payload) {
    if (payload) {
      state.squareCard = payload
    }
    else {
      state.squareCard = null
    }
  },
  SET_CURRENCIES: function(state, payload) {
    state.currencies = payload
  },
  PAYMENT_DETAILS: function(state, payload) {
    state.paymentDetails = payload || null
  },
  SET_DEFAULT_CURRENCY: function(state, payload) {
    state.dflt_currency = payload
  },
  SET_SITE_SETTINGS: function(state, payload) {
    state.site_settings = payload
  },
  PROCESSING_RESULT: function(state, payload) {
    state.processingResult = payload || null
  },
  PROCESSING_REQUEST: function(state, payload) {
    state.processingRequest = payload || null
  },
  PAYMENT_INIT_ERROR: function(state, payload) {
    state.paymentInitError = payload || null
  },
  PAYMENT_TXN: function(state, payload) {
    state.paymentTxn = payload || null
  },
  LOCATIONS: function(state, payload) {
    state.locations = payload || []
  },
  SET_LOCATIONS_BY_TXNTYPE: function(state, payload) {
    state.locationsByTxnType = payload || {}
  },
  SET_TRANSACTION_TYPES: function(state, payload) {
    state.transactionTypes = payload || {}
  },
  SET_TERMINAL_DEVICES: function(state, payload) {
    state.terminalDevices = payload || []
  },
  SET_TERMINAL_DEVICE_CODES: function(state, payload) {
    state.terminalDeviceCodes = payload || []
  },
  SET_SELECTED_TERMINAL_DEVICE: function(state, payload) {
    state.selectedTerminalDeviceId = payload || null
  },
  TERMINAL_PAYMENT_PROCESSING: function(state, payload) {
    state.terminalPaymentProcessing = payload || false
  },
  REGISTER_ACCELERATED_TXN_HANDLERS: function(state, payload) {
    state.AcceleratedTransactionHandler = payload
  }

}
